import { useEffect, useState } from 'react';
import { getOwnSubjectRecord } from '../../StudentRecord/services/studentRecordService';

export function useOwnSubjectRecord(subjectId) {
  const [subject, setSubject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    setError('');

    getOwnSubjectRecord(subjectId)
      .then((result) => {
        if (!mounted) return;
        if (!result) {
          setError('No record found for this subject.');
          setSubject(null);
        } else {
          setSubject(result);
        }
      })
      .catch((err) => {
        if (mounted) setError(err.message || 'Failed to load subject');
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [subjectId]);

  return { subject, loading, error };
}
